// SPDX-License-Identifier: AGPL-3.0-or-later

import {MarkdownContext, type RendererProps} from '@app/features/messaging/components/markdown/renderers/RendererTypes';
import type {TextNode} from '@app/vendor/markdown_parser/types/Nodes';
import type React from 'react';
export function TextRenderer({node, id, options}: RendererProps<TextNode>): React.ReactElement {
	let content = node.content;
	if (options.context === MarkdownContext.RESTRICTED_INLINE_REPLY) {
		content = content.replace(/\n/g, ' ').replace(/\s+/g, ' ');
	}
	return <span key={id}>{content}</span>;
}
